import type { FC, ReactElement } from "react";
import { Navigate } from "react-router-dom";

import { hasValidAffiliatePortalSession } from "../../utils/tokenUtils";
import { AFFILIATE_PORTAL_SIGN_IN_ROUTE } from "../../routing/affiliatePortalRoutes";

type RequireAffiliateAuthProps = {
  children: ReactElement;
};

/**
 * Route guard for `/affiliate-portal/*`. Three conditions must hold:
 *   1. We have a persisted portal token bundle.
 *   2. The local-clock expiry hasn't passed.
 *   3. The IdToken's `cognito:groups` claim contains `"affiliates"` — staff
 *      tokens or mis-routed PAM users get bounced even if the structural
 *      shape would otherwise let them in.
 */
const RequireAffiliateAuth: FC<RequireAffiliateAuthProps> = ({ children }) => {
  if (!hasValidAffiliatePortalSession()) {
    return <Navigate to={AFFILIATE_PORTAL_SIGN_IN_ROUTE} replace />;
  }
  return children;
};

export default RequireAffiliateAuth;
